import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react';
import { PrimaryButton, DefaultButton } from '@fluentui/react';
import { getId } from '@fluentui/react';
// import { hiddenContentStyle, mergeStyles } from '@fluentui/react';
import { ContextualMenu } from '@fluentui/react';
import InfoTooltip from '../formFields/InfoTooltip';
import {TextField} from '@fluentui/react';

// const screenReaderOnly = mergeStyles(hiddenContentStyle);

export interface IDialogBasicExampleState {
    hideDialog: boolean;
    isDraggable: boolean;
}

export class ModalDialog extends React.Component<{}, IDialogBasicExampleState> {
     state: IDialogBasicExampleState = {
        hideDialog: true,
        isDraggable: false,
        comment: null
    };
    // Use getId() to ensure that the IDs are unique on the page.
    // (It's also okay to use plain strings without getId() and manually ensure uniqueness.)
     _labelId: string = getId('dialogLabel');
     _subTextId: string = getId('subTextLabel');
     _dragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };

    onWriteEvent (e,v) {
        if(v.length > 0)
        {
            this.setState({warning: false})
        }
      
        this.setState({comment: v});
    }

     render() {
        const { hideDialog, isDraggable } = this.state;
        return (
            <div>
                <DefaultButton disabled={this.props.btnDisabled} primary={this.props.btnPrimary} className={this.props.btnClassName} secondaryText="" onClick={this._showDialog} text={this.props.buttonName} />
                {(this.props.tooltip ? <InfoTooltip content={this.props.tooltip} /> : null)}
                <Dialog
                    hidden={hideDialog}
                    onDismiss={this._closeDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: this.props.title,
                        subText: this.props.text
                    }}
                    modalProps={{
                        titleAriaId: this._labelId,
                        subtitleAriaId: this._subTextId,
                        isBlocking: false,
                        styles: { main: { maxWidth: 450 } },
                        dragOptions: isDraggable ? this._dragOptions : undefined
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={this._confirm} text="Confirm" />
                        <DefaultButton onClick={this._closeDialog} text="Cancel" />
                    </DialogFooter>

                    {(this.props.textField ?
                        <TextField
                            label="Please provide justification"
                            name="Comment"
                            onChange={this.onWriteEvent.bind(this)}
                            validationResult={this.state.commentValidation}
                            multiline
                            rows={3}
                            errorMessage={this.state.warning ? "Comment required" : null}
                        />
                    : null)}
                </Dialog>
            </div>
        );
    }

    _confirm = () : void => {
        if(this.props.textField && (this.state.comment == null || this.state.comment.length === 0))
        {
            this.setState({warning:true})
            return;
        }

        this.props.actionConfirmed(this.state.comment);
        this.setState({ hideDialog: true });
    }

    _showDialog = (): void => {
        this.setState({ hideDialog: false });
        this.props.onClick && this.props.onClick();
    };

     _closeDialog = (): void => {
        this.setState({ hideDialog: true });
        this.props.onCancel && this.props.onCancel();
    };

     _toggleDraggable = (): void => {
        this.setState({ isDraggable: !this.state.isDraggable });
    };
}


// WEBPACK FOOTER //
// ./src/components/formFields/Dialog.js